import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotDataDisplayComponent } from './not-data-display.component';

@NgModule({
  declarations: [NotDataDisplayComponent],
  imports: [
    CommonModule
  ],
  exports: [
    NotDataDisplayComponent
  ]
})
export class NotDataDisplayModule { }
